import { Injectable } from '@angular/core';
import { MemberProxyService } from 'src/app/member/service/member-proxy.service';
import { checkIsMobile } from 'src/app/util';


/** GA log 服務 */
@Injectable({
  providedIn: 'root'
})
export class GALoggerService {
  constructor(
    private memberProxyService: MemberProxyService,
  ) {}

  log(data: any) {
    if (this.memberProxyService.hasLoginSystem && this.memberProxyService.memberInfo) {
      data['client_id'] = this.memberProxyService.memberInfo.memberId;
    }
    data['site_domain'] = checkIsMobile() ? 'APP' : 'PC';
    window['dataLayer'].push(data);
  }
}
